import { Component, OnInit, TemplateRef, Input, HostListener, AfterViewInit, OnDestroy, NgZone  } from "@angular/core";
import { Router, NavigationEnd } from '@angular/router'; 
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Destino } from "../../entidades/destino";
import { DestinoService } from "../../servicios/destino.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { CotizacionService } from "../../servicios/cotizacion.service";
import { recolecciondom } from "../../servicios/recoleccion-dom.service";
import * as bootstrap from 'bootstrap';
import { AnalyticsService } from 'src/app/servicios/analytics.service';

declare const bootstrap: any;

@Component({
  selector: "app-cotizacion-form",
  templateUrl: "./cotizacion-form.component.html",
  styleUrls: ["./cotizacion-form.component.css"],
})
export class CotizacionFormComponent implements OnInit, AfterViewInit, OnDestroy {
  btnVenta2?: boolean;

  heroForm: FormGroup;
  cotizaForm: FormGroup;
  recoleccionForm: FormGroup;
  rastreo = false;
  heroPos = "cotizar";
  // variables
  origenSeleccionado: Destino;
  destinoSeleccionado: Destino;
  modalRef: BsModalRef;
  TitleModal: string;
  tipo: string;
  ciudades: any;
  submitted = false;
  submittedRec = false;
  mySlideOptions = {
    items: 1,
    dots: true,
    nav: false,
    lazyLoad: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
  };

  idestado: number;
  idciudad: number;
  idcolonia: number;
  cadestados: any[];
  cadciudades: any[];
  cadcolonias: any[];

  selected: any = "";
  // carousel: any;
  carousel1:any;
  showModal = false;

    /** Carruseles y handlers separados para no pisarnos */
  private mainCarousel?: bootstrap.Carousel;
  private modalCarousel?: bootstrap.Carousel;
  private routerSub?: any;
   private onSlidMain?: EventListener;
  private onSlidModal?: EventListener;
  // private onSlidHandler?: (e: Event) => void;
  private io?: IntersectionObserver;

  constructor(
    private destinoService: DestinoService,
    private modalService: BsModalService,
    private router: Router,
    private cotizacionService: CotizacionService,
    private recolecciondom: recolecciondom,
    private zone: NgZone,
    private analytics: AnalyticsService
  ) {}

  ngOnInit() {
    this.destinoService.origenSeleccionado.subscribe(
      (data) => (this.origenSeleccionado = data)
    );
    this.destinoService.destinoSeleccionado.subscribe(
      (data) => (this.destinoSeleccionado = data)
    );
    this.cotizacionService
      .getCiudades().subscribe((datos) => (this.ciudades = datos));
    this.recolecciondom.getestados().subscribe((data) => {
      this.cadestados = data;
    });

    this.createForm();

    if (localStorage.getItem("opMenu") == "viajes") {
      this.btnVenta2 = true;
    }
    if (localStorage.getItem("opMenu") == "compra") {
      this.btnVenta2 = false;
    }



// Reforzar reproducción al volver a la ruta
    this.routerSub = this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        setTimeout(() => this.playActiveSlideVideoIn(document.getElementById('carouselPromos')), 0);
      }
    });
  }

 ngAfterViewInit() {
    this.initMainCarousel();

    // iOS a veces necesita un pequeño "gesto" para soltar el autoplay programático
    this.zone.runOutsideAngular(() => {
      const kickstart = () => {
        const el = document.getElementById('carouselPromos');
        this.playActiveSlideVideoIn(el);
        window.removeEventListener('touchstart', kickstart);
        window.removeEventListener('click', kickstart);
      };
      window.addEventListener('touchstart', kickstart, { once: true });
      window.addEventListener('click', kickstart, { once: true });
    });
  }

  ngOnDestroy(): void {
    // Listeners carrusel principal
    const mainEl = document.getElementById('carouselPromos');
    if (mainEl && this.onSlidMain) mainEl.removeEventListener('slid.bs.carousel', this.onSlidMain);
    // Listeners carrusel modal
    const modalEl = document.getElementById('carouselPromos2');
    if (modalEl && this.onSlidModal) modalEl.removeEventListener('slid.bs.carousel', this.onSlidModal);

    this.routerSub?.unsubscribe?.();
    this.pauseAllVideosIn(document.getElementById('carouselPromos'));
    this.pauseAllVideosIn(document.getElementById('carouselPromos2'));

    this.mainCarousel?.dispose?.();
    this.modalCarousel?.dispose?.();

    this.io?.disconnect();
  }

  /** ---------- Inicialización y control del carrusel principal ---------- */
  private initMainCarousel(): void {
    const el = document.getElementById('carouselPromos');
    if (!el) return;

    this.mainCarousel = new bootstrap.Carousel(el, {
      interval: false,
      ride: false,
      pause: false,
      touch: true
    });

    // Reproduce solo el slide activo
    this.playActiveSlideVideoIn(el);

    // Cuando cambie el slide, reproducir el nuevo y pausar el resto
    this.zone.runOutsideAngular(() => {
      this.onSlidMain = () => this.playActiveSlideVideoIn(el);
      el.addEventListener('slid.bs.carousel', this.onSlidMain);
    });

    // Pausar si el carrusel sale de viewport (mejora batería y evita glitches en móvil)
    this.io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === el) {
          if (entry.isIntersecting) {
            this.playActiveSlideVideoIn(el);
          } else {
            this.pauseAllVideosIn(el);
          }
        }
      });
    }, { threshold: 0.25 });
    this.io.observe(el);
  }

  /** ---------- Inicialización y control del carrusel en modal ---------- */
  private initModalCarousel(): void {
    const el = document.getElementById('carouselPromos2');
    if (!el || this.modalCarousel) return; // ya inicializado

    this.modalCarousel = new bootstrap.Carousel(el, {
      interval: false,
      ride: false,
      pause: false,
      touch: true
    });

    // Importante: el modal abre con transición. Espera un tic para asegurar visibilidad.
    setTimeout(() => this.playActiveSlideVideoIn(el), 0);

    this.zone.runOutsideAngular(() => {
      this.onSlidModal = () => this.playActiveSlideVideoIn(el);
      el.addEventListener('slid.bs.carousel', this.onSlidModal);
    });
  }


 /** Reproduce solo el video del slide activo y pausa los demás */
  private playActiveSlideVideoIn(root?: HTMLElement | null): void {
    if (!root) return;
    const slides = Array.from(root.querySelectorAll<HTMLElement>('.carousel-item'));

    slides.forEach(slide => {
      const video = slide.querySelector<HTMLVideoElement>('video.promo-video');
      if (!video) return;

      if (slide.classList.contains('active')) {
        // Asegurar flags iOS
        video.muted = true;
        video.setAttribute('playsinline', '');
        (video as any).setAttribute?.('webkit-playsinline', '');

        // Evitar que empiece de mitad si vienes de pausa
        // (si no quieres reiniciar, comenta la línea de currentTime)
        // video.currentTime = 0;

        // Intento de reproducción controlado
        if (video.paused) {
          video.play().catch(() => {
            // iOS puede rechazar antes de un gesto; se intenta de nuevo en kickstart o al abrir modal
          });
        }
      } else {
        if (!video.paused) video.pause();
      }
    });
  }

  private pauseAllVideosIn(root?: HTMLElement | null): void {
    if (!root) return;
    root.querySelectorAll<HTMLVideoElement>('video.promo-video').forEach(v => {
      if (!v.paused) v.pause();
    });
  }

  private resetAllVideosIn(root?: HTMLElement | null): void {
    if (!root) return;
    root.querySelectorAll<HTMLVideoElement>('video.promo-video').forEach(v => {
      try { v.pause(); v.currentTime = 0; } catch {}
    });
  }


 
  mostrarmodalmobil(){
    this.showModal = true;

     // 📊 Evento GA4/GTM: se abrió el slider móvil
  this.analytics.event('show_BannerPromociones_mobile', {
    dispositivo: 'mobile',
    origen: 'Home'
  });

      // Espera la transición del overlay antes de inicializar y reproducir
    setTimeout(() => {
      this.initModalCarousel();
      const el = document.getElementById('carouselPromos2');
      this.playActiveSlideVideoIn(el);
    }, 220);
  }


  close() {
    // Pausa y reinicia para que NO quede corriendo detrás del overlay
    const el = document.getElementById('carouselPromos2');
    this.resetAllVideosIn(el);

    // Limpia listeners del carrusel modal
    if (el && this.onSlidModal) el.removeEventListener('slid.bs.carousel', this.onSlidModal);
    this.modalCarousel?.dispose?.();
    this.modalCarousel = undefined;

    this.showModal = false;
  }

  createForm() {
    this.heroForm = new FormGroup({
      rastreo: new FormControl("", [Validators.required]),
    });

    this.cotizaForm = new FormGroup({
      origen: new FormControl("0", [Validators.required]),
      destino: new FormControl("0", [Validators.required]),
    });

    this.recoleccionForm = new FormGroup({
      estado: new FormControl("", [Validators.required]),
      ciudad: new FormControl("", [Validators.required]),
      colonia: new FormControl("", [Validators.required]),
    });
  }

  get a() {
    return this.recoleccionForm.controls;
  }

  estadoChanged(idedo) {
    this.recoleccionForm.controls.ciudad.setValue("");
    this.recoleccionForm.controls.colonia.setValue("");
    this.idestado = idedo;
    this.get_ciudades();
  }

  get_ciudades() {
    this.recolecciondom.getciudad(this.idestado).subscribe((data) => {
      this.cadciudades = data;
    });
  }

  ciudadChanged(idcd) {
    this.recoleccionForm.controls.colonia.setValue("");
    this.idciudad = idcd;
    this.recolecciondom
      .getcolonia(this.idestado, this.idciudad)
      .subscribe((data) => {
        this.cadcolonias = data;
      });
  }

  coloniaChanged(idcol) {
    this.idcolonia = idcol;
  }

  openModal(template: TemplateRef<any>, tipo) {
    if (tipo === "O") {
      this.TitleModal = "Origen";
      this.tipo = "O";
    } else {
      this.TitleModal = "Destino";
      this.tipo = "D";
    }
    this.modalRef = this.modalService.show(template);
  }

  opMenu(num: number) {
    this.selected = "";
    if (num == 0) {
      this.selected = "viajes";
    } else if (num == 1) {
      this.selected = "agregar";
    }
    localStorage.setItem("opMenu", this.selected);
  }

  itemSelector(value) {
    console.log("Entro al itemSelector");
    let bg = document.getElementById("background");
    let fm = document.getElementById("formularioi");
    let im = document.getElementById("imageni");

    switch (value) {
      case "cotizar":
        fm.style.opacity = "0";
        bg.style.backgroundImage =
          "linear-gradient(rgba(0,0,0,0.5), rgba(0, 0, 0, 0.5)), url('assets/img/hero/promociones/3.jpg')";
        this.heroPos = "cotizar";
        break;

      case "rastreo":
        this.heroPos = "rastreo";
        break;

      case "recoleccion":
        im.style.opacity = "0";
        bg.style.backgroundImage =
          "linear-gradient(rgba(0,0,0,0.5), rgba(0, 0, 0, 0.5)), url('assets/img/hero/promocion3.jpg')";
        this.router.navigate(["/herramientas-menu"]);
        this.recoleccionForm.value.estado = "Sonora";
        break;

      case "promociones":
        fm.style.opacity = "0";
        im.style.opacity = "0";
        bg.style.backgroundImage = "none";
        bg.style.backgroundColor = "#000";
        this.heroPos = "promociones";
        break;
    }
  }

  async sendRastreo() {
    let codes = [];
    if (this.heroForm.value.rastreo) {
      if (sessionStorage.getItem("codes")) {
        await sessionStorage.removeItem("codes");
      }
      codes.push(this.heroForm.value.rastreo);
      await sessionStorage.setItem("codes", JSON.stringify(codes));

      this.router.navigate(["/paqueteria/rastreo/captura"], {
        queryParams: { codigo: this.heroForm.value.rastreo },
      });
    }
  }

  getCotizacion() {
    this.submitted = true;
    if (this.cotizaForm.valid) {
      if (
        this.cotizaForm.value.origen !== "0" &&
        this.cotizaForm.value.destino !== "0"
      ) {
        this.cotizacionService.setOrigen(this.cotizaForm.value.origen);
        this.cotizacionService.setDestino(this.cotizaForm.value.destino);
        this.router.navigate(["/cotizacion"]);
      }
    }
  }

  getRecoleccion() {
    this.submittedRec = true;
    if (this.recoleccionForm.valid) {
      if (
        this.recoleccionForm.value.estado !== "0" &&
        this.recoleccionForm.value.ciudad !== "0" &&
        this.recoleccionForm.value.colonia !== "0"
      ) {
        this.recolecciondom.setEstado(this.recoleccionForm.value.estado);
        this.recolecciondom.setCiudad(this.recoleccionForm.value.ciudad);
        this.recolecciondom.setColonia(this.recoleccionForm.value.colonia);

        this.router.navigate(["/paqueteria/recoleccion"]);
      }
    }
  }

  activarRastreo() {
    let elem = document.getElementById("rastreo");
    elem.classList.add("rastreo-active");
  }
  bindText(value1, value2) {
    return value1 + " " + value2;
  }

onSlideClick(eventName: string, urlDestino: string, dispositivo: string) {
  this.analytics.event(eventName, { url_destino: urlDestino, dispositivo });
}
}
